<template>
  <span class="text-icon">
    <i
      class="icon"
      :style="{
        width: iconWidth,
        height: iconHeight,
        backgroundPosition: iconPosition
      }"
    ></i>
    <span><slot /></span>
  </span>
</template>

<script>
  export default {
    props: {
      iconSize: { type: String, required: true },
      iconPos: { type: String, required: true },
    },
    computed: {
      iconPosition () {
        return this.iconX + ' ' + this.iconY
      },
      iconX () {
        return this.iconPos.split(',')[0] + 'px'
      },
      iconY () {
        return this.iconPos.split(',')[1] + 'px'
      },
      iconWidth () {
        return this.iconSize.split(',')[0] + 'px'
      },
      iconHeight () {
        return this.iconSize.split(',')[1] + 'px'
      }
    }
  }
</script>


<style scoped lang="scss">
  .text-icon {
    display: inline-flex;
    align-items: center;

    .icon {
      background-image: url('~@/assets/img/sprite.png');
      background-repeat: no-repeat;
      margin-right: 5px;
    }
  }
</style>